import { render, staticRenderFns } from "./basico.vue?vue&type=template&id=6ade6a1a&scoped=true"
import script from "./basico.vue?vue&type=script&lang=js"
export * from "./basico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ade6a1a",
  null
  
)

export default component.exports